export const STORAGE_KEYS = {
  bearerToken: 'BearerToken',
  refreshToken: 'RefreshToken',
  userInfo: 'UserInfo',
  userRole: 'UserRole',
  rolePermissions: 'RolePermissions',
  isSiteSelected: 'IsSiteSelected',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];

export function getStorageItem(key: StorageKey): string | null {
  return localStorage.getItem(key);
}

export function setStorageItem(key: StorageKey, value: string): void {
  localStorage.setItem(key, value);
}

export function getBearerToken(): string | null {
  return getStorageItem(STORAGE_KEYS.bearerToken);
}

export function getUserInfoRaw(): string | null {
  return getStorageItem(STORAGE_KEYS.userInfo);
}

export function getUserInfoJson<T extends object = Record<string, unknown>>(
  fallback: T
): T {
  try {
    const raw = getUserInfoRaw();
    return raw ? (JSON.parse(raw) as T) : fallback;
  } catch {
    return fallback;
  }
}

